import React, { useContext , useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import {
  Linha,
  MenuItemFilhoContainer,
  OpcaoItem,
  PopupCustomizadoPerfil,
  TextoItem,
  TextoPerfil,
} from "../Header/styles";
import { ReactComponent as IconeConta } from "../../assets/icons/account_circle.svg";
import useTamanhoTela from "../../utils/useTamanhoTela";

import { ReactComponent as IconeContaCheio } from "../../assets/icons/account_circle_filled.svg";
import { ReactComponent as IconeSair } from "../../assets/icons/exit_to_app.svg";
import { useApi } from "../../contexts/api";
import { useMenu } from "../../contexts/menu";

import { faGear, faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import BotaoEngrenagem from "../BotaoEngrenagem";
import Switch from "../Switch";
import { TemaCustomizadoContext } from "../../contexts/theme";
import { realizarLogoff as realizarLogoffCashback } from "../../pages/plataformaCashback/api";
import { useLoader } from "../../contexts/loader";

export const Perfil = React.forwardRef(
  ({ nome, style, onClick, largura }, ref) => {
    const theme = useTheme();
    return (
      <Linha style={style} onClick={onClick} ref={ref}>
        {largura > 1000 ? <TextoPerfil>Olá, {nome}</TextoPerfil> : ""}
        <IconeConta style={{ fontSize: 32, fill: theme.cores.textoSimples }} />
      </Linha>
    );
  },
);

export const PerfilPopup = ({
  style,
  setAberto,
  plataformaCashback,
  onAbrirConfiguracoes,
}) => {
  const { largura } = useTamanhoTela();
  const theme = useTheme();
  const { abrirCarregamento } = useLoader();
  const { realizarLogoff } = useApi();
  const desconectar = () => {
    setAberto(false);
    abrirCarregamento();
    plataformaCashback ? realizarLogoffCashback() : realizarLogoff();
  };

  return (
    <>
      <MenuItemFilhoContainer
        className="item-ver-perfil"
        style={{
          padding: "0px 4px",
          gap: "8px",
        }}
      >
        {!plataformaCashback && (
          <>
            <IconeContaCheio />
            <p>Ver Perfil</p>
          </>
        )}
      </MenuItemFilhoContainer>
      {largura <= 1000 && onAbrirConfiguracoes && (
        <MenuItemFilhoContainer
          style={{
            padding: "0px 4px",
            gap: "8px",
          }}
          onClick={onAbrirConfiguracoes}
        >
          <FontAwesomeIcon
            style={{
              marginRight: "2px",
              fontSize: "16px",
              color: theme.cores.neutral60,
              alignSelf: "center",
            }}
            icon={faGear}
          />
          <p>Configurações</p>
        </MenuItemFilhoContainer>
      )}
      {largura <= 1000 && !onAbrirConfiguracoes && (
        <BotaoEngrenagem
          renderTrigger={({ onClick }) => (
            <MenuItemFilhoContainer
              style={{
                padding: "0px 4px",
                gap: "8px",
              }}
              onClick={() => {
                setAberto(false);
                onClick();
              }}
            >
              <FontAwesomeIcon
                style={{
                  marginRight: "2px",
                  fontSize: "16px",
                  color: theme.cores.neutral60,
                  alignSelf: "center",
                }}
                icon={faGear}
              />
              <p>Configurações</p>
            </MenuItemFilhoContainer>
          )}
        />
      )}
      <MenuItemFilhoContainer
        style={{
          padding: "0px 4px",
          gap: "8px",
        }}
        onClick={desconectar}
      >
        <IconeSair />
        <p>Sair</p>
      </MenuItemFilhoContainer>
    </>
  );
};

const BotaoPerfil = ({ style }) => {
  const [aberto, setAberto] = useState(false);
  const [openSignalConfiguracoes, setOpenSignalConfiguracoes] = useState(0);
  const theme = useTheme();
  const { abrirCarregamento } = useLoader();
  const { dadosUsuario } = useMenu();
  const { largura } = useTamanhoTela();
  const { mudarTema } = useContext(TemaCustomizadoContext);
  const { realizarLogoff } = useApi();

  const validarNomeUsuario = (usuario) => {
    try {
      const nome = usuario.nome.split(" ");
      return nome[0];
    } catch (error) {
      return "Usuário";
    }
  };

  const desconectar = () => {
    setAberto(false);
    abrirCarregamento();
    realizarLogoff();
  };

  useEffect(() => {
    setAberto(false);
  }, [largura]);

  const abrirConfiguracoesMobile = () => {
    setAberto(false);
    setOpenSignalConfiguracoes((prev) => prev + 1);
  };

  return (
    <>
      <BotaoEngrenagem
        openSignal={openSignalConfiguracoes}
        renderTrigger={() => null}
      />
      <PopupCustomizadoPerfil
        trigger={
          <Perfil
            largura={largura}
            nome={validarNomeUsuario(dadosUsuario)}
            onClick={() => setAberto(!aberto)}
            style={style}
          />
        }
        onClose={() => setAberto(false)}
        onOpen={() => setAberto(true)}
        open={aberto}
        position="bottom center"
        arrowStyle={{ visibility: "hidden" }}
        offsetY={12}
      >
        <OpcaoItem>
          <Switch
            onClick={() => {
              mudarTema();
            }}
            checked={!theme.temaDarkAtivo}
            valor={!theme.temaDarkAtivo}
            mudarTema
            texto="Alterar tema"
            styleLabel={{
              fontFamily: "Comfortaa",
              fontSize: 16,
              whiteSpace: "nowrap",
            }}
          />
        </OpcaoItem>

        {largura <= 1000 && (
          <OpcaoItem onClick={abrirConfiguracoesMobile} efeito>
            <FontAwesomeIcon
              style={{
                marginRight: "6px",
                fontSize: "16px",
                color: theme.cores.neutral60,
              }}
              icon={faGear}
            />
            <TextoItem>Configurações</TextoItem>
          </OpcaoItem>
        )}
        <OpcaoItem onClick={desconectar} efeito>
          <FontAwesomeIcon
            style={{
              marginRight: "6px",
              fontSize: "16px",
              color: theme.cores.neutral60,
            }}
            icon={faRightFromBracket}
          />
          <TextoItem>Desconectar</TextoItem>
        </OpcaoItem>
      </PopupCustomizadoPerfil>
    </>
  );
};

export default BotaoPerfil;
